import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../../services/language/language.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  currentYear = new Date().getFullYear();
  appVersion: string | null = null;

  constructor(public languageService: LanguageService) {}

  translate(key: string): string {
    return this.languageService.translate(key);
  }

  ngOnInit(): void {
    // Prefer the value injected by the deploy pipeline (window.APP_VERSION),
    // fallback to the meta tag if present.
    try {
      const w = window as any;
      if (w && typeof w.APP_VERSION !== 'undefined' && w.APP_VERSION !== null) {
        this.appVersion = String(w.APP_VERSION);
        return;
      }
    } catch {
      // ignore
    }

    try {
      const meta = document.querySelector('meta[name="app-version"]');
      this.appVersion = meta?.getAttribute('content') || null;
    } catch {
      // ignore
    }
  }
}
